import styles from './Button.module.scss';
import {useAppSelector} from "../../../../redux/hook";
import {selectViewState} from "../../../../redux/features/view/viewSlice";
import EditablePanel from "../../shared/editable/EditablePanel";
import {DeleteType} from "../../../model/DeleteOption";
import {SettingGroupType, SettingOption, SettingType} from "../../../model/SettingOption";
import React, {useContext, useState} from "react";
import {StyleUtil} from "../../setting/StyleUtil";
import {WidgetInterface} from "../../../model/WidgetInterface";
import {nanoid} from "nanoid";
import VariableContext from "../../../../context/VariableContext";
import useWidgetState from "../../../../hook/useWidgetState";

export default function Button(props: any) {

    const widgetData:WidgetInterface = props.data as WidgetInterface;
    const {widgetId,widgetProps} = widgetData;
    const variableContext = useContext(VariableContext);
    const viewState = useAppSelector(selectViewState);
    const [refreshId,setRefreshId] = useState(nanoid());
    useWidgetState(widgetId,(event:CustomEvent) => {
        setRefreshId(nanoid());
    });


    if(!widgetProps['content']) {
        widgetProps['content'] = {
            label: "Button"
        }
    }

    if(StyleUtil.isDefaultStyle(widgetProps['bt_button'])) {
        widgetProps['bt_button'] = {
            style: {
                default: true,
                dimension: {
                    width: "250px",
                    height: "auto",
                },
                margin: {
                    'margin-inline-start': 'auto',
                    'margin-inline-end': 'auto',
                    'margin-block-start': '16px',
                    'margin-block-end':'16px'
                }
            }
        };
    }

    const themeName = "button";
    const widgetStyle = {
        theme: StyleUtil.toThemeNameByType(widgetProps, themeName),
        current: StyleUtil.toClassFromWidget(widgetId, widgetProps, "current_style"),
        button: StyleUtil.toClassFromWidget(widgetId , widgetProps, "bt_button")
    }

    const createButton = () => {
        let label = variableContext.updateVariables(widgetProps["content"]['label']);
        let href = variableContext.updateVariables(widgetProps['content']['href']);
        let openLink = widgetProps['content']['openLink'];
        if(!openLink) {
            openLink = "_self";
        }
        if(viewState.isEdit === false) {
            return <div className={styles.Root}>
                <a key={refreshId}
                   href={`href{src}`}
                   target={openLink}
                   className={StyleUtil.combineClasses("btn",widgetStyle.theme, widgetStyle.current, widgetStyle.button)}
            >{label}</a></div>;
        } else {
            return <div className={styles.Root}>
                <a key={refreshId}
                   href={`${href}`}
                   target={openLink}
                   style={{pointerEvents:"none"}}
                   className={StyleUtil.combineClasses("btn",widgetStyle.theme, widgetStyle.current, widgetStyle.button)}

            >{label}</a></div>;
        }

    }

    if(viewState.isEdit) {
        let deleteOption = {type: DeleteType.delete_with_rearrange, tag: null};
        const suggestTags: string[] = [
            "current",
        ]
        let settingOptions:SettingOption[] = [
            { title: "", type: SettingType.widget,  editor: "buttonsetting" , group: "content", groupType: SettingGroupType.layout},
            { type: SettingType.dimension, group: "bt_button", groupType: SettingGroupType.style},
            { type: SettingType.typography, group: "bt_button", groupType: SettingGroupType.style},
            { type: SettingType.object, group: "bt_button", groupType: SettingGroupType.style},
            { type: SettingType.border, group: "bt_button", groupType: SettingGroupType.style},
            { type: SettingType.border_radius, group: "bt_button", groupType: SettingGroupType.style},
            { type: SettingType.box_shadow, group: "bt_button", groupType: SettingGroupType.style},
            { type: SettingType.margin, group: "bt_button", groupType: SettingGroupType.advanced},
            { type: SettingType.padding, group: "bt_button", groupType: SettingGroupType.advanced},
        ];
        return <EditablePanel {...props}
                              themeName={themeName}
                              suggestTags={suggestTags}
                              settingOptions={settingOptions}
                              settingGroups={[
                                      {group: "content", groupName: "Content", groupType: SettingGroupType.layout},
                                      {group: "bt_button", groupName: "Style", groupType: SettingGroupType.style},
                                  ]
                              }
                              deleteOption={deleteOption}>
                    {createButton()}
                </EditablePanel>
    } else {
        return createButton();
    }
}